//名片活跃轨迹接口

import { API, http } from './index';

// 企微侧边栏活跃轨迹
export const queryListOfWeChat = data => http.get(API.active.queryListOfWeChat, data);


// 企微侧边栏活跃轨迹
export const queryValueByIdAndCode = data => http.get(API.active.queryValueByIdAndCode, data);

//营销推送 - 直播间列表
export const allLiveList = data => http.get(API.active.allLiveList, data);

// 营销轨迹 - 留言记录
export const queryMessageRecordApi = data => http.get(API.active.queryMessageRecord, data);






export default {
    queryListOfWeChat,
    queryValueByIdAndCode,
    allLiveList,
    queryMessageRecordApi
};